<template>
  <div class="commentaries-window-component">
    <h1 class="window-title font-weight-regular">
      Комментарий: <!--для курьера-->
    </h1>

    <div class="button-group-section d-flex justify-space-between mb-8">
      <v-row dense class="justify-space-between">
        <v-col sm="5">
          <v-btn
            width="100%"
            class="button button-back"
            color="#F1F3F6"
            @click="back"
          >
            <font-awesome-icon icon="chevron-left" />
            Вернуться назад
          </v-btn>
        </v-col>
        <v-col sm="5">
          <big-apply-btn
            :disabled="!isEdited"
            :loading="loading"
            @click="saveComment"
          />
        </v-col>
      </v-row>
    </div>

    <v-alert
      v-if="disableEdit"
      class="comments-window-alert"
      type="info"
      color="#fff3d6"
    >
      Редактирование комментария возможно только у незавершенных заказов
    </v-alert>

    <div class="basket-comment-section ">
      <!--      <span class="label">Комментарий:</span>-->
      <v-textarea
        v-model="comment"
        :loading="loading"
        :disabled="disableEdit"
        hide-details="auto"
        placeholder="Введите комментарий"
        class="textarea"
        solo
        flat
        height="370px"
        no-resize
      />
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import BigApplyBtn from '@/components/ui/buttons/BigApplyBtn.vue'
  import store from '@/store'
  import OrderStatus from '@/models/enums/OrderStatus'
  import OrderEdit from '@/mixins/order-edit'
  import OrderHelp from '@/components/order-processing/order-components/aside/OrderHelp.vue'

  export default {
    name: 'CourierCommentWindow',
    components: { OrderHelp, BigApplyBtn },
    mixins: [
      OrderEdit,
    ],
    data () {
      return {
        comment: null,
        loading: false,
      }
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
        orderStatus: state => state.baskets.orderStatus,
      }),
      basketComment () {
        return this.basket?.commentForCourier
      },
      isEdited () {
        return this.basketComment !== this.comment
      },
      disableEdit () {
        const statusesNotAccessEdit = [
          OrderStatus.Completed,
          OrderStatus.Canceled,
        ]

        return statusesNotAccessEdit.includes(this.orderStatus)
      },
    },
    watch: {
      basketComment: {
        handler (val) {
          this.comment = val
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      async saveComment () {
        this.loading = true

        if (!this.basket?.id) {
          return
        }

        try {
          const data = {
            value: this.comment,
            id: this.basket?.id,
          }
          await this.$store.dispatch('baskets/updateCommentForCourier', data)
          this.closeCommentWindow()
          this.showSuccessMessage('Комментарий обновлен')
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.loading = false
      },
      back () {
        if (this.isEdited) {
          this.$store.dispatch('confirmDialog/show', {
            title: 'Вы действительно хотите покинуть страницу?',
            content: 'Комментарий был изменен но не сохранен',
            onConfirm: () => this.closeCommentWindow(),
            onCancel: () => false,
          })
        } else {
          this.closeCommentWindow()
        }
      },
      closeCommentWindow () {
        this.$store.commit('fastOrder/setCurrentOtherWindow', undefined)
      },
    },
  }
</script>

<style lang="less" scoped>
  .commentaries-window-component {
    .window-title {
      font-size: 34px;
      line-height: 21px;
      margin-bottom: 32px;
    }

    .comments-window-alert {
      position: relative;
      margin-bottom: 30px;
      background-color: #fff3d6;
      border-radius: 10px;
      //padding: 21px 12px 13px;
      color: #000;
      font-size: 14px;

      ::v-deep {
        .v-icon {
          color: #E1CD9D;
        }
      }

    }

    .label {
      display: block;
      margin-bottom: 16px;
      font-size: 20px;
      line-height: 21px;
    }

    .textarea {
      ::v-deep {
        &.v-input__slot {
          border-radius: 15px;
          background-color: @color-secondary;
        }
      }
    }

    .button {
      height: 80px;
      background-color: @color-secondary;
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;
      border-radius: 10px !important;
      font-weight: 500;

      &.v-item--active {
        background-color: @color-primary !important;
        color: #ffffff;
      }

      &:before {
        display: none;
      }

      svg {
        margin-right: 8px;
      }

      &.button-back {
        svg {
          .fill-svg(#0033ff);
        }
      }
    }

    .button-group-section {
      margin-bottom: 26px;
    }

    .food-comment-section {
      .ps {
        margin-right: -12px;
      }
      .food-cards {
        padding-right: 24px;
        max-height: 408px;
      }
    }
  }
</style>
